import type {ReactElement} from 'react';
import {FontControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-control/font-control';
import type {HeadingFontControlProps} from './heading-font-control.types';

export function HeadingFontControl({component}: HeadingFontControlProps): ReactElement {
  return <FontControl component={component} />;
}
